import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { fetchMetrics } from '../../../services/metrics';
import { Card, Typography, Spinner, ErrorComponent } from '../../../components';
import * as S from './MetricsCards.styles';
import { SOURCES } from '../../../../constants/general.constants';

export const MetricsCards = ({ className }) => {
	const [loadingStatus, setLoadingStatus] = useState('idle');
	const [metrics, setMetrics] = useState([]);

	async function initializeData() {
		setLoadingStatus('loading');
		try {
			const {
				data: { result },
			} = await fetchMetrics({ source: SOURCES.PLATFORM });
			setMetrics(result.metrics);
			setLoadingStatus('success');
		} catch (error) {
			setLoadingStatus('error');
		}
	}

	useEffect(() => {
		if (loadingStatus === 'idle') {
			initializeData();
		}
	}, []);

	const renderContent = () => {
		switch (loadingStatus) {
			case 'loading':
				return <Spinner />;
			case 'error':
				return <ErrorComponent />;
			case 'success':
				return (
					<>
						<Card className="metric-card">
							<Typography tag="h1" weight="extrablack">
								{metrics?.teacherCount}
							</Typography>
							<Typography tag="h6" weight="semibold">
								Teachers
							</Typography>
						</Card>
						<Card className="metric-card">
							<Typography tag="h1" weight="extrablack">
								{metrics?.employeeCount}
							</Typography>
							<Typography tag="h6" weight="semibold">
								Company Members
							</Typography>
						</Card>
						<Card className="metric-card">
							<Typography tag="h1" weight="extrablack">
								{metrics?.schoolCount}
							</Typography>
							<Typography tag="h6" weight="semibold">
								Schools
							</Typography>
						</Card>
						<Card className="metric-card">
							<Typography tag="h1" weight="extrablack">
								{metrics?.companyCount}
							</Typography>
							<Typography tag="h6" weight="semibold">
								Companies
							</Typography>
						</Card>
					</>
				);
			default:
				return null;
		}
	};

	return <S.CardWrapper className={className}>{renderContent()}</S.CardWrapper>;
};

MetricsCards.propTypes = {
	className: PropTypes.string,
};
